module.exports = __webpack_public_path__ + "static/media/hourglass-end.e06ad80a.svg";